import { z } from 'zod';

export enum Countries {
    US = 'US',
    CA = 'CA',
    GB = 'GB',
    AU = 'AU',
}

function isLink(string: string) {
    const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/\S*)?$/;
    return urlPattern.test(string);
}

export const schema = z
    .object({
        country: z.string(),
        businessAddress: z.string(),
        companyRegisterNumber: z.string(),
        companyWebsite: z.string(),
        legalBusinessName: z.string(),
        phoneNumber: z.string(),
        street: z.string(),
        city: z.string(),
        region: z.string(),
        postalCode: z.string(),
    })
    .refine(
        (data) => {
            if (data.country === Countries.US || data.country === Countries.CA || data.country === Countries.AU) {
                return data.phoneNumber;
            }
            return true;
        },
        {
            message: 'Phone number is required.',
            path: ['phoneNumber'],
        }
    )
    .refine(
        (data) => {
            if (data.country === Countries.GB) {
                return /^\d{3,13}$/.test(data.companyRegisterNumber);
            }
            return true;
        },
        {
            message: 'Required',
            path: ['companyRegisterNumber'],
        }
    )
    .refine(
        (data) => {
            if (data.country === Countries.GB) {
                return data.legalBusinessName;
            }
            return true;
        },
        {
            message: 'Required',
            path: ['legalBusinessName'],
        }
    )
    .refine(
        (data) => {
            if (data.country === Countries.GB) {
                return isLink(data.companyWebsite);
            }
            return true;
        },
        {
            message: 'Required',
            path: ['companyWebsite'],
        }
    )
    .refine(
        (data) => {
            if (data.country === Countries.GB || data.country === Countries.CA || data.country === Countries.AU) {
                return data.street;
            }
            return true;
        },
        {
            message: 'Required',
            path: ['street'],
        }
    )
    .refine(
        (data) => {
            if (data.country === Countries.GB || data.country === Countries.CA || data.country === Countries.AU) {
                return data.city;
            }
            return true;
        },
        {
            message: 'Required',
            path: ['city'],
        }
    )
    .refine(
        (data) => {
            if (data.country === Countries.GB || data.country === Countries.CA || data.country === Countries.AU) {
                return data.region;
            }
            return true;
        },
        {
            message: 'Required',
            path: ['region'],
        }
    )
    .refine(
        (data) => {
            if (data.country === Countries.GB || data.country === Countries.CA || data.country === Countries.AU) {
                return data.postalCode;
            }
            return true;
        },
        {
            message: 'Required',
            path: ['postalCode'],
        }
    )
    .refine(
        (data) => {
            if (data.country === Countries.CA || data.country === Countries.AU) {
                return data.businessAddress;
            }
            return true;
        },
        {
            message: 'Required',
            path: ['businessAddress'],
        }
    );
